import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { CLOSE_BOTTOM_TAB, OPEN_BOTTOM_TAB, REORDER_TABS, SET_BOTTOM_TAB_INDEX } from "./types";
export var setBottomTabIndex = function setBottomTabIndex(newIndex) {
    return /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(dispatch) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1)
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt("return", dispatch({
                                type: SET_BOTTOM_TAB_INDEX,
                                newIndex: newIndex
                            }));
                        case 1:
                        case "end":
                            return _context.stop();
                    }
            }, _callee);
        }));
        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var reorderBottomTabs = function reorderBottomTabs(newOrder, newIndex) {
    return /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(dispatch) {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1)
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            return _context2.abrupt("return", dispatch({
                                type: REORDER_TABS,
                                newIndex: newIndex,
                                newOrder: newOrder
                            }));
                        case 1:
                        case "end":
                            return _context2.stop();
                    }
            }, _callee2);
        }));
        return function (_x2) {
            return _ref2.apply(this, arguments);
        };
    }();
};
export var openBottomTab = function openBottomTab(tab) {
    return /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(dispatch) {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1)
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            return _context3.abrupt("return", dispatch({
                                type: OPEN_BOTTOM_TAB,
                                tab: tab
                            }));
                        case 1:
                        case "end":
                            return _context3.stop();
                    }
            }, _callee3);
        }));
        return function (_x3) {
            return _ref3.apply(this, arguments);
        };
    }();
};
export var closeBottomTab = function closeBottomTab(closeTab) {
    return /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(dispatch) {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1)
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            return _context4.abrupt("return", dispatch({
                                type: CLOSE_BOTTOM_TAB,
                                closeTab: closeTab
                            }));
                        case 1:
                        case "end":
                            return _context4.stop();
                    }
            }, _callee4);
        }));
        return function (_x4) {
            return _ref4.apply(this, arguments);
        };
    }();
};
